import { DistributeTemplateWebRoute } from '../sign/router/constants/templates';

export const shouldShowDistributeTemplateApp = () => {
  return DistributeTemplateWebRoute.isSamePath(window.location.pathname);
};
